import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { lighten, List, ListItem, ListItemButton, ListItemText } from '@mui/material';
import { ChevronRight } from '@mui/icons-material';
import { memo, useMemo } from 'react';
export const PagesList = memo(function PagesList(props) {
    const { dividers, chevrons, pages, changeSelectedTab } = props;
    const items = useMemo(() => pages.map(({ key, title, selected, warning, error, data_tooltip }) => (_jsx(ListItem, { onClick: () => setImmediate(() => changeSelectedTab(key)), divider: dividers, disablePadding: true, sx: (theme) => ({
            background: selected ? theme.palette.primary.main : undefined,
            transitionProperty: 'background-color, color',
            ...(warning && {
                background: theme.palette.warning.light,
                color: theme.palette.warning.contrastText,
                '&:hover': {
                    background: lighten(theme.palette.warning.light, 0.2),
                },
                '& .MuiTypography-body2': {
                    color: lighten(theme.palette.warning.contrastText, 0.2),
                },
            }),
            ...(error && {
                background: theme.palette.error.light,
                color: theme.palette.error.contrastText,
                '& .MuiTypography-colorTextSecondary': {
                    color: theme.palette.error.contrastText,
                },
                '&:hover': {
                    background: lighten(theme.palette.error.light, 0.2),
                },
            }),
        }), "data-tooltip": data_tooltip ?? '', children: _jsxs(ListItemButton, { selected: selected, children: [_jsx(ListItemText, { primary: title, secondary: error
                        ? 'Есть ошибки'
                        : warning
                            ? 'Есть предупреждения'
                            : null }), chevrons && _jsx(ChevronRight, {})] }) }, key))), [pages, dividers, chevrons]);
    return (_jsx(List, { className: "DialogMobileFooter", sx: { py: 0 }, children: items }));
});
